export function Loading ({ scale = 1.0, text = "Loading..." }) {
	return (
		<div className="relative flex justify-center items-center" style={ { height: 128 * scale } }>
			<div className="animate-spin absolute rounded-full border-t-2 border-b-2 border-neutral-300" style={ { height: 96 * scale, width: 96 * scale } } />
			<div className="text-neutral-400 text-sm font-bold">{ text }</div>
		</div>
	);
};

export default Loading;